import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-female-lymphatic-walking',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['walking'],
	},
	landing: {
		ids: ['loader-lymphatic-walking-f', 'age-lymphatic-walking-f'],
		route: {
			path: '/lymphatic-walking-f',
			name: 'lymphatic-walking-funnel',
		},
	},
	funnel: {
		id: 'ob-female-activity-lymphatic-walking',
		route: {
			path: '/lymphatic-walking-f/ob/:page(.*)?',
			name: 'activity-female-lymphatic-walking',
		},
		slug: 'activity-female-lymphatic-walking',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-lymphatic-walking-f',
	},
	upsell: {
		routeNames: ['upsell-activity-f'],
	},
}

export default appAreaConfig
